'use client'
import { Button } from 'app/_components/Button'
import { forwardRef } from 'react'

export default forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof Button> & { toggleAction?: () => void }
>(function SidebarTrigger(
  { children, onClick, className, toggleAction, ...props },
  _,
) {
  return (
    <form action={toggleAction}>
      <Button
        shape="icon"
        variant="ghost"
        type="submit"
        className={className}
        {...props}
      >
        {children}
      </Button>
    </form>
  )
})
